import { lazy } from 'react';

import { logger } from '../utils';

export const CHUNK_RELOAD_FLAG = 'nv:chunk-reload';

/**
 * Wrap a dynamic-import factory so it survives a deploy swapping the chunks.
 *
 * Every build emits assets under fresh hashes and drops the previous ones, so
 * a tab opened before a deploy gets a 404 the first time it navigates to a
 * lazy route and the import rejects. Production hit this twice: a 404 on
 * SettingsPage-uXKMQQkX.js from /settings/knowledge-base, and one on
 * SignupForm-BvREFTuw.js from /signup. Reload once to pick up the current
 * bundle; a second consecutive failure is a genuine error and is rethrown
 * rather than looping the tab.
 */
export function withChunkReload(factory) {
  return () => factory()
    .then((module) => {
      sessionStorage.removeItem(CHUNK_RELOAD_FLAG);
      return module;
    })
    .catch((error) => {
      if (sessionStorage.getItem(CHUNK_RELOAD_FLAG)) throw error;
      logger.error('Chunk failed to load, reloading once to pick up the current build', error);
      sessionStorage.setItem(CHUNK_RELOAD_FLAG, '1');
      window.location.reload();
      // Stay pending so nothing renders while the reload takes over.
      return new Promise(() => {});
    });
}

/** `lazy()` built on {@link withChunkReload}. */
export function lazyWithReload(factory) {
  return lazy(withChunkReload(factory));
}
